export var AppleIAPProductId;
(function (AppleIAPProductId) {
    AppleIAPProductId["ProPlanYearly"] = "pro_plan_yearly";
    AppleIAPProductId["PlusPlanYearly"] = "plus_plan_yearly";
})(AppleIAPProductId || (AppleIAPProductId = {}));
